import { useDispatch, useSelector } from 'react-redux';
import ActiveAssetDashboard from './ActiveAssetDashboard'
import { useEffect, useState } from 'react'
import { getAssetEoneDetails } from 'Store/AssetManagement/AssetEoneDetails/AssetEoneDetailsAction';
import { useNavigate, useParams } from 'react-router-dom';
import navOperations from "redux/Navigation/operations";
import moment from 'moment';
import { CONSTANTS } from 'client/utils/constants';
import { getBarcodeReportDashboardAssetImages } from 'Store/Report/BarcodeReport/BarcodeReportAction';

const ActiveAssetDashboardContainer = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);

  let { assetnumber, pagename } = useParams();

  ///selectors
  const {
    assetEoneDetails
  }: any = useSelector((state: any) => ({
    assetEoneDetails: state.AssetEoneDetailsReducer.assetEoneDetails
  }));
  let initialAuditDetails = {
    header: '',
    details: null,
    currentYear: '',
    priorYearWithPrefix: '',
    priorYear: ''
  }
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [auditHistoryDetails, setAuditHistoryDetails] = useState(initialAuditDetails);
  const [itemStatus, setItemStatus] = useState('');
  const [Popupcontent, setPopupcontent] = useState({
    header: '',
    popupType: '',
    size: ''
  });

  useEffect(() => {
    dispatch(getAssetEoneDetails(assetnumber));
  }, [])

  useEffect(() => {
    if (assetEoneDetails?.activeAsset?.activeAssetHeader?.assetNumber) {
      let val = assetEoneDetails?.orderHistory?.find((item?: any) => item?.orderNumber == assetEoneDetails?.activeAsset?.activeAssetHeader?.orderNumber)
      setItemStatus(val?.itemStatus)
    }
  }, [assetEoneDetails])

  const handleClickBack = (e?: any) => {
    e.preventDefault();
    if (pagename === 'barcodereport') {
      navigate('/ordermanagement/BarcodeReplacement');
    } else {
      navigate('/ordermanagement/activeasset');
    }
  }

  const breadcrumlist = [
     pagename === 'barcodereport'
    ? {
      text: "Barcode Replacement",
      key: "f1",
      href: "/ordermanagement/BarcodeReplacement",
      onClick: (e: any) => {
        e.preventDefault();
        handleClickBack(e)
      },
    }: {
      text: "Home",
      key: "f1",
      href: "/ordermanagement",
      onClick: (e: any) => {
        e.preventDefault();
        navigate('/ordermanagement');
        dispatchNav('Home');
        dispatchHeaderNav('Home');
      },
    },
    {
      text: "Active Assets Dashboard",
      key: "f2",
      href: "/ordermanagement/activeasset",
      onClick: (e: any) => {
        e.preventDefault();
        handleClickBack(e)
      },
    },
    { text: "Active Assets Drill Through", key: "f2" },
    {}
  ];

  const columns = [
    {
      key: 'requestType',
      title: 'Request Type',
      Cell: (row: any) => {
        return (
          row.rowData.requestType ?? '-'
        );
      },
      width: '150px'
    },
    {
      key: 'orderNumber',
      title: 'Order #',
      Cell: (row: any) => {
        return (
          <a href={ onClickOrder(row.rowData.requestType, row.rowData.orderNumber)} rel='noreferrer noopener' target='_blank' className="order-link-id">
            {row.rowData.orderNumber ?? '-'}
          </a>
        );
      },
      width: '150px'
    },
    {
      key: 'requestDate', title: 'Date', width: '150px',
      Cell: (row: any) => {
        return (
          moment(row?.rowData?.requestDate)?.format("MM/DD/YYYY") ?? '-'
        );
      }
    },
  ];

  const onClickOrder = (requestType?: any, orderNumber?: any) => {
    if (requestType == 'Requisition' || requestType == CONSTANTS.PRODUCTION_VEHICLE || requestType == CONSTANTS.MANAGEMENT_VEHICLE || requestType == CONSTANTS.MANAGED_EQUIPMENT || requestType == CONSTANTS.NON_STANDARD_EQUIPMENT) {
      return('/ordermanagement/requisitionorderdetail/' + orderNumber + '/activeasset/' + assetnumber);
    } else {
      return('/ordermanagement/assetorderdetail/' + orderNumber + '/activeasset/' + assetnumber);
    }
  }

  const onClickAssetNumber = (e?: any, childAssetNumber?: any) => {
    e.preventDefault();
    navigate('/ordermanagement/activeasset/activeassetdashboard/' + childAssetNumber);
    dispatch(getAssetEoneDetails(childAssetNumber));
  }

  const onClickAuditCycleYear = (e?: any, item?: any) => {
    e.preventDefault();
    if(item?.isScanned){
    let headerVal = getAuditName(item);
    let yearDetails = getAuditYear(item);
    setAuditHistoryDetails({
      header: headerVal,
      details: item,
      currentYear: yearDetails.currentYear,
      priorYearWithPrefix: yearDetails.priorYearWithPrefix,
      priorYear: yearDetails.priorYear.toString()
    });
    setPopupcontent({
      header: headerVal,
      popupType: 'audit',
      size: 'large'
    });
    setShowModalPopup(true);
  }
  }

  const closeModalPopup = (e?: any) => {
    e.preventDefault();
    setShowModalPopup(false);
    setAuditHistoryDetails(initialAuditDetails);
    setPopupcontent({
      header: '',
      popupType: '',
      size: ''
    });
  }

  const onClickAssetImages = (e?: any) => {
    e.preventDefault();
    setShowModalPopup(true);
    dispatch(getBarcodeReportDashboardAssetImages(assetnumber))
    setPopupcontent({
      header: 'Asset Images',
      popupType: 'assetImages',
      size: 'medium-large'
    });
  }

  const getAuditName = (item?: any) => {
    let val = 'FY'
    let year = item?.auditCycleYear?.toString()?.substring(2, 4)
    val = val + year
    if (!item?.isInScope) {
      val = val + ' Out of Scope'
    } else {
      if (item?.isInScope && item?.isScanned) {
        val = val + ' Scan Data'
      } else {
        val = val + ' Not Scanned'
      }
    }
    return val;
  }

  const getAuditYear = (item?: any) => {
    let val = 'FY'
    let year = item?.auditCycleYear?.toString()?.substring(2, 4)
    let yearVal = {
      currentYear: val + year,
      priorYearWithPrefix: val + (year - 1),
      priorYear: item?.auditCycleYear - 1
    }
    return yearVal;
  }

  const currentAndPriorTableValues = (key: any) => {
    return auditHistoryDetails?.details != null ? auditHistoryDetails?.details[key] != null ? auditHistoryDetails?.details[key] : '-' : '-';
  }

  const getPriorYearBarCodeValue = () => {
    if(assetEoneDetails != null && auditHistoryDetails?.priorYear != ''){
    let barcodeFilteredItems = assetEoneDetails?.activeAssetAuditHistory?.filter((item: any) => item?.auditCycleYear == auditHistoryDetails?.priorYear);
    if (barcodeFilteredItems?.length == 1) {
      return barcodeFilteredItems[0]?.barcodeScannedUsed != null ? barcodeFilteredItems[0]?.barcodeScannedUsed : '-';
    } else if (barcodeFilteredItems?.length > 1) {
      let val = [...barcodeFilteredItems].sort((a: any, b: any) => b?.auditOperationDateUTC - a?.auditOperationDateUTC);
      return val[0]?.barcodeScannedUsed != null ? val[0]?.barcodeScannedUsed : '-';
    }else{
      return '-'
    }
  }
  }

  const audithistory_data = [
    {
      conditionReport: 'Condition Type',
      CurrentYear: currentAndPriorTableValues('conditionType'),
      PriorYear: currentAndPriorTableValues('lastConditionType')
    },
    {
      conditionReport: 'Mileage Hour',
      CurrentYear: currentAndPriorTableValues('milageHour'),
      PriorYear: currentAndPriorTableValues('lastMilageHour')
    },
    {
      conditionReport: 'Condition Comments',
      CurrentYear: currentAndPriorTableValues('conditionComments'),
      PriorYear: currentAndPriorTableValues('lastConditionComments'),
    },
    {
      conditionReport: 'BarCode Scanned Used',
      CurrentYear: currentAndPriorTableValues('barcodeScannedUsed'),
      PriorYear: getPriorYearBarCodeValue()
    }
  ];

  const audithistory_columns = [
    { field: 'conditionReport', title: 'Condition Report', width: '200px' },
    { field: 'CurrentYear', title: `${auditHistoryDetails?.currentYear} Current`, width: '200px' },
    { field: 'PriorYear', title: `${auditHistoryDetails?.priorYearWithPrefix}  (Prior Year)`, width: '200px' },
  ];

  const handleLocationClick = (auditHistoryDetails: any) => {
    const { latitude, longitude } = auditHistoryDetails || {};
    if (latitude != null && longitude != null) {
      window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, '_blank');
    }
  };

  const handleImageClick = (event: React.MouseEvent<HTMLImageElement>) => {
    // Get the 'src' of the clicked image
    const imageUrl = event.currentTarget.src;
    window.open(imageUrl, '_blank');
  };
const displayValue = (value: any) => {
        return value === null || value === undefined || value === '' ? '-' : value;
    };
  return (
    <ActiveAssetDashboard
      columns={columns}
      breadcrumlist={breadcrumlist}
      handleClickBack={handleClickBack}
      assetEoneDetails={assetEoneDetails}
      onClickOrder={onClickOrder}
      onClickAssetNumber={onClickAssetNumber}
      onClickAuditCycleYear={onClickAuditCycleYear}
      showModalPopup={showModalPopup}
      closeModalPopup={closeModalPopup}
      getAuditName={getAuditName}
      auditHistoryDetails={auditHistoryDetails}
      audithistory_columns={audithistory_columns}
      audithistory_data={audithistory_data}
      itemStatus={itemStatus}
      handleLocationClick={handleLocationClick}
      handleImageClick = {handleImageClick}
      onClickAssetImages={onClickAssetImages}
      popupcontent={Popupcontent}
      displayValue={displayValue}
    />

  )
}

export default ActiveAssetDashboardContainer